import { render } from "./salary-certificat-valid.vue?vue&type=template&id=09935f2c"
import script from "./salary-certificat-valid.vue?vue&type=script&lang=js"
export * from "./salary-certificat-valid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__